<template>
  <div class="row" v-for="color in colors" :key="color.id">
    <div v-show="visible(color.color)">
      <CategoryColorComponent :title="$t('catalog.colors.' + color.color)" />
    </div>
    <div class="col-6 col-lg-3" v-for="rose in premiumColor(color.color)" :key="rose.id" id="rose-col" v-show="
  visible(rose.color, rose.length, rose.vaselife)
">
      <RoseComponent :rose-name="rose.name" :length="rose.length" :bloom="rose.bloom" :petals="rose.petals"
        :vaselife="rose.vaselife" :img="require(`../assets/roses/` + rose.img)" />
    </div>
  </div>
</template>

<script>
import RoseComponent from "./RoseComponent.vue";
import CategoryColorComponent from "./CategoryColorComponent.vue";
import premiumRosesArray from "../data/premium-roses.json";
import colorsArray from "../data/premium-colors.json";
export default {
  name: "PremiumRosesList",
  inject: ["checked"],
  components: {
    RoseComponent,
    CategoryColorComponent,
  },
  data() {
    return {
      premiumRoses: premiumRosesArray,
      colors: colorsArray,
    };
  },
  methods: {
    premiumColor(color) {
      return this.premiumRoses.filter((rose) => rose.color === color);
    },
    visible: function (color, length, vaselife) {
      var isInColor = 0;
      var isInLength = 0;
      var isInVaselife = 0;
      function checkDifference(difference, lastTwo, currentLength) {
        var iteration = difference / 10;
        for (var j = 0; j < iteration; j++) {
          if (lastTwo - difference == currentLength) {
            isInLength = 1;
          }
          difference = difference - 10;
        }
      }

      for (var i = 0; i < this.checked.color.length; i++) {
        if (color == this.checked.color[i]) {
          isInColor = 1;
        }
      }

      for (i = 0; i < this.checked.lengths.length; i++) {
        if (typeof length == "string") {
          var firstTwo = length.substring(0, 2);
          var lastTwo = length.substring(3);
          var difference = lastTwo - firstTwo;
          if (firstTwo == this.checked.lengths[i]) {
            isInLength = 1;
          } else if (lastTwo == this.checked.lengths[i]) {
            isInLength = 1;
          } else if (difference > 10) {
            checkDifference(difference, lastTwo, this.checked.lengths[i]);
          }
        }
      }

      for (i = 0; i < this.checked.vaselife.length; i++) {
        if (vaselife == this.checked.vaselife[i]) {
          isInVaselife = 1;
        }
      }
      const lengths = this.checked.lengths.length ? isInLength : true;
      const colors = this.checked.color.length ? isInColor : true;
      const vaselifes = this.checked.vaselife.length ? isInVaselife : true;

      if (colors && lengths && vaselifes) {
        return true;
      } else {
        return false;
      }
    },
  },

};
</script>
